import getWeeklyIntervals from "./getWeeklyIntervals";

export default function getParsedAvailableTimePeriods(
  schedule: Schedule,
  timezone: TimeZone,
): ParsedAvailableTimePeriod[] {
  return schedule.map(({ available_intervals, start_date, end_date }) => ({
    start_date,
    end_date,
    intervals: getWeeklyIntervals(available_intervals, timezone),
    recurring: !end_date,
  }));
}
